import React from 'react';
import { Card } from '../ui/Card';
export function AgingChart() {
  // This would normally use a charting library like recharts
  // For now, we'll create a simple visualization with divs
  const agingData = [{
    label: '0-30 giorni',
    value: 120000,
    color: 'bg-[#00C853]/70'
  }, {
    label: '31-60 giorni',
    value: 75000,
    color: 'bg-[#FFB84D]/70'
  }, {
    label: '61-90 giorni',
    value: 45000,
    color: 'bg-[#FFB84D]'
  }, {
    label: '90+ giorni',
    value: 60000,
    color: 'bg-[#FF6B81]'
  }];
  const total = agingData.reduce((sum, item) => sum + item.value, 0);
  return <Card title="Crediti per Anzianità" data-id="element-584">
      <div className="space-y-4" data-id="element-585">
        <div className="h-4 w-full flex rounded-full overflow-hidden" data-id="element-586">
          {agingData.map((item, index) => <div key={index} className={`${item.color}`} style={{
          width: `${item.value / total * 100}%`
        }} data-id="element-587" />)}
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4" data-id="element-588">
          {agingData.map((item, index) => <div key={index} className="flex flex-col" data-id="element-589">
              <div className="flex items-center" data-id="element-590">
                <div className={`w-3 h-3 rounded-full ${item.color} mr-2`} data-id="element-591" />
                <span className="text-sm text-gray-500" data-id="element-592">{item.label}</span>
              </div>
              <span className="text-lg font-medium" data-id="element-593">
                €{(item.value / 1000).toFixed(1)}k
              </span>
            </div>)}
        </div>
      </div>
    </Card>;
}